module.exports = __webpack_public_path__ + "img/back_last.25640afc.png";